import React, { useState, useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import Select from './SelectWrapper/Select';

import APIRequest from '~/lib/api_request';

const LabelSelect = ({
  id,
  name,
  value = '',
  placeholder = 'Select a Label',
  onChange,
  isMulti,
  isInvalid,
  isClearable,
  isSearchable,
  addBlank,
}) => {
  const isMounted = useRef(true);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    APIRequest.get(
      { resource: '/v1/labels' },
    ).end((error, response) => {
      if (isMounted.current) {
        if (!error) {
          const fetchedOptions = response.body.map((label) => ({
            label: `${label.name} (${label.leads_count})`,
            value: label.id,
          }));
          setOptions(fetchedOptions);
        }

        setIsLoading(false);
      }
    });

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <Select
      id={id}
      name={name}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      addBlank={addBlank}
      isMulti={isMulti}
      isInvalid={isInvalid}
      isLoading={isLoading}
      isClearable={isClearable}
      isSearchable={isSearchable}
    />
  );
};

LabelSelect.defaultProps = {
  id:           '',
  name:         '',
  placeholder:  'Select a Label',
  onChange:     () => {},
  value:        '',
  isMulti:      false,
  isInvalid:    false,
  isClearable:  false,
  isSearchable: false,
  addBlank:     false,
};

LabelSelect.propTypes = {
  id:          PropTypes.string,
  name:        PropTypes.string,
  placeholder: PropTypes.string,
  onChange:    PropTypes.func,
  value:       PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.shape({}),
  ]),
  isMulti:      PropTypes.bool,
  isInvalid:    PropTypes.bool,
  isClearable:  PropTypes.bool,
  isSearchable: PropTypes.bool,
  addBlank:     PropTypes.bool,
};

export default LabelSelect;
